<div class="container" [class.disabled]="disabled">
  <input [disabled]="disabled" type="number" [value]="value" (change)="change($event)" [min]="min" [placeholder]="placeholder">
  <ng-container *ngIf="!disabled">
    <button type="button" class="up" (click)="incr(1)"></button>
    <button type="button" class="down" (click)="incr(-1)"></button>
  </ng-container>
</div>
